import buildCorrectGrammarText from "Common/componentUtils/buildCorrectGrammarText";
export default {
    buildCountSummaryReportsTitle: (count) => `${count} ${buildCorrectGrammarText(count, ["отчет", "отчета", "отчетов"])}`,
    CREATE_SUMMARY_REPORT: "Создать отчет"
};
